import React from "react";
import useReveal from "../hooks/useReveal";

/**
 * Обёртка для scroll-reveal анимации. Оборачивает блок — он плавно
 * появляется снизу при попадании во вьюпорт.
 *
 * props:
 *   as       — тег обёртки (по умолчанию div)
 *   delay    — задержка появления, мс (для каскада)
 *   variant  — "up" (по умолчанию) | "scale" | "left" | "right"
 */
export default function Reveal({
  children,
  as: Tag = "div",
  delay = 0,
  variant = "up",
  className = "",
  ...rest
}) {
  const [ref, visible] = useReveal();

  return (
    <Tag
      ref={ref}
      className={`rb-reveal rb-reveal--${variant} ${
        visible ? "rb-reveal--in" : ""
      } ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
